import { render, staticRenderFns } from "./orderFundDetail.vue?vue&type=template&id=2eba13ce&"
import script from "./orderFundDetail.vue?vue&type=script&lang=js&"
export * from "./orderFundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports